import Trombinoscope from "../donnesrh/trombinoscope";
import { useTranslation } from "react-i18next";

/**
 * Annuaire de l'entreprise accessible au manager. Les fiches sont limitées
 * aux données RH, sans contrat, informations personnelles ou historique.
 */
export default function TrombinoscopeManager() {
    const { t } = useTranslation();
    return (
        <Trombinoscope
            title={t("Trombinoscope des collaborateurs")}
            emptyMessage={t("Aucun collaborateur trouvé.")}
            rhOnly
        />
    );
}
